module.exports = __webpack_public_path__ + "img/InE-2.00c13e26.jpg";